import { Component, OnInit } from '@angular/core';
import { Validators, FormControl, NG_VALIDATORS, Form } from '@angular/forms';
import { MatDialogRef, MatMenuModule, MatFormFieldModule, MatDialog, MatRadioModule } from '@angular/material';
import { InfodialogComponent } from '../infodialog/infodialog.component';

@Component({
  selector: 'app-sketchbyxydialog',
  templateUrl: './sketchbyxydialog.component.html',
  styleUrls: ['./sketchbyxydialog.component.scss']
})
export class SketchbyxydialogComponent implements OnInit {

  constructor(public sketchByXYDialog: MatDialogRef<SketchbyxydialogComponent>, public dialog: MatDialog) { }

  latlong: string;

  degreelat: string;
  degreelong: string;

  dmslat: string;
  dmslong: string;

  dmlat: string;
  dmlong: string;

  dmslatlong: string;

  selectedFormat: string = '';
  gpsformats: string[] = ['Coordinated (Format: Lat, Long)', 'Degrees (Format: D.D)', 'Degrees Minutes Seconds (Format: D M S)', 'Degrees Minutes (Format: D M.M)'];

  submitted = false;

  ngOnInit() {
  }

  OnCloseConfirm() {
    this.submitted = true;
    switch (this.selectedFormat) {
      case 'Coordinated (Format: Lat, Long)':
        this.sketchByXYDialog.close(this.latlong);
        break;

      case 'Degrees (Format: D.D)':
        var dglong = "-" + this.degreelong;
        this.latlong = this.degreelat + "," + dglong;
        this.sketchByXYDialog.close(this.latlong);
        break;

      case 'Degrees Minutes Seconds (Format: D M S)':

        var dmslongnew = "-" + this.dmslong;
        var dmslatsplit = this.dmslat.split(' ');
        var dmslongsplit = dmslongnew.split(' ');

        if (dmslatsplit.length != 3 || dmslongsplit.length != 3) {
          let infoalert = this.dialog.open(InfodialogComponent, {
            width: '500px',
            data: {
              title: 'Alert',
              content: 'One of the values is in the wrong format.'
            }
          });
          break;
        }

        if (!this.checkDegreeVal(dmslatsplit[1]) || !this.checkDegreeVal(dmslongsplit[1])) {
          let infoalertnew = this.dialog.open(InfodialogComponent, {
            width: '500px',
            data: {
              title: 'Alert',
              content: 'Degree value needs to be between 0 - 180.'
            }
          });
          break;
        }
        this.dmsToLonLat(this.dmslat, dmslongnew);
        break;

      case 'Degrees Minutes (Format: D M.M)':
        var dmlongnew = "-" + this.dmlong;
        var dmlatsplit = this.dmlat.split(' ');
        var dmlongsplit = dmlongnew.split(' ');

        if (dmlatsplit.length != 2 || dmlongsplit.length != 2) {
          let infoalert = this.dialog.open(InfodialogComponent, {
            width: '500px',
            data: {
              title: 'Alert',
              content: 'One of the values is in the wrong format.'
            }
          });
          break;
        }

        if (!this.checkDegreeVal(dmlatsplit[1]) || !this.checkDegreeVal(dmlongsplit[1])) {
          let infoalertnew = this.dialog.open(InfodialogComponent, {
            width: '500px',
            data: {
              title: 'Alert',
              content: 'Degree value needs to be between 0 - 180.'
            }
          });
          break;
        }
        if (!this.checkMinSecVal(dmlatsplit[1]) || !this.checkMinSecVal(dmlongsplit[1])) {
          let infoalertnew = this.dialog.open(InfodialogComponent, {
            width: '500px',
            data: {
              title: 'Alert',
              content: 'Minutes and Second value needs to be between 0 - 59.'
            }
          });
          break;
        }
        this.dmToLonLat(this.dmlat, dmlongnew);
        break;

    }
  }

  checkDegreeVal(val) {
    return val >= -180 && val <= 180;
  }

  checkMinSecVal(val) {
    return val >= 0 && val <= 59;
  }

  dmsToLonLat(xText, yText) {
    var x = this.dmsTextToDegrees(xText);
    var y = this.dmsTextToDegrees(yText);
    this.dmslatlong = x + " , " + y;
    this.sketchByXYDialog.close(this.dmslatlong);
  }

  dmsTextToDegrees(text) {
    var degree = 0;
    var minutes = 1;
    var seconds = 2;
    var parts = text.split(' ');

    var d = parts[degree];
    var m = parts[minutes] / 60;
    var s = parts[seconds] / 3600;
    var pretext = (d > 0) ? '' : '-';
    return pretext + (Math.abs(d) + m + s).toString();
  }

  dmToLonLat(xText, yText) {
    var x = this.dmTextToDegrees(xText);
    var y = this.dmTextToDegrees(yText);
    var dmlatlong = x + " , " + y;
    this.sketchByXYDialog.close(dmlatlong);
  }

  dmTextToDegrees(text) {
    var degree = 0;
    var minmils = 1;
    var min = 0;
    var ms = 1;

    var parts = text.split(' ');
    var msText = parts[minmils];
    var mParts = msText.split('.');

    var d = parts[degree];
    var m = msText / 60;
    var pretext = (d > 0) ? '' : '-';
    return pretext + (Math.abs(d) + m).toString();
  }

  focusError(form) {
    this.submitted = false;
    switch (this.selectedFormat) {
      case 'Coordinated (Format: Lat, Long)':
        form.form.controls.latlongname.touched = true;
        break;

      case 'Degrees (Format: D.D)':
        form.form.controls.degreelatname.touched = true;
        form.form.controls.degreelongname.touched = true;
        break;

      case 'Degrees Minutes Seconds (Format: D M S)':
        form.form.controls.dmslatname.touched = true;
        form.form.controls.dmslongname.touched = true;
        break;

      case 'Degrees Minutes (Format: D M.M)':
        form.form.controls.dmlatname.touched = true;
        form.form.controls.dmlongname.touched = true;
        break;

    }
  }

  OnCloseCancel() {
    this.sketchByXYDialog.close('Cancel');
  }
}